import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Navigate } from "react-router-dom";
import GraficoPregunta from "./GraficoPregunta";
import GraficoHorizontal from "./GraficoHorizontal";
import GraficoHorizontal1 from "./GraficoHorizontal1";
import GraficoHorizontal2 from "./GraficoHorizontal2";

import GraficoDonut from "./GraficoDonut";
import DetalleCalculosEvaluado from "./DetalleCalculosEvaluado";
import { esAdmin } from "../config/superadmins";
import {
  ExclamationTriangle as Icon_Gem,
  FileEarmarkBarGraph as Icon_File,
  ChevronDown as Icon_ChevronDown,
  ChevronUp as Icon_ChevronUp,
  PersonLinesFill as Icon_Ficha,
} from "react-bootstrap-icons";

import {
  getEncuestas,
  setFormulario,
  setPreguntaActiva,
  getUsuario,
  setAnswer,
  getReporte,
} from "../actions";

import {
  Container,
  Row,
  Col,
  Button,
  ListGroup,
  Table,
  Form,
  Spinner,
  Collapse,
} from "react-bootstrap";

import { Decimation } from "chart.js";

// Datos cargados dinámicamente desde el backend (dbo.GetReporte) en
// lugar de los JSON estáticos que usa el reporte de calibración 251204.
// Este componente es la plantilla para todos los procesos productivos.
const ID_PROCESO = "260521";

// Temporal: el detalle expandible (chevron) muestra los gráficos por evaluado y
// es visible para los administradores del cliente. Mientras definimos qué exponer
// del comparativo norma/grupo, dejamos el dropdown deshabilitado. La ficha
// individual (/ficha/:id) sigue accesible por su botón propio.
// Para reactivar el dropdown: poner DETALLE_EXPANDIBLE = true.
const DETALLE_EXPANDIBLE = false;

const Reporte260521 = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const usuario = useSelector((state) => state.usuario);

  // Admin (perfil 2 o 3): habilita el botón de ficha detallada por evaluado.
  const ticket = useSelector((state) => state.ticket);
  const _esAdmin = esAdmin(ticket);

  console.log("usuario.Detail 3", usuario);

  const [values, setValues] = useState({});
  const [expandedRows, setExpandedRows] = useState({});

  // Filtros del listado "Resumen por Evaluado" (combinan con AND).
  const [filtroResultado, setFiltroResultado] = useState("");
  const [filtroNombre, setFiltroNombre] = useState("");
  const [filtroRut, setFiltroRut] = useState("");
  // Filtros por valor exacto de cada criterio crítico.
  const [filtroRiesgos, setFiltroRiesgos] = useState("");
  const [filtroJuicio, setFiltroJuicio] = useState("");
  const [filtroAF, setFiltroAF] = useState("");
  const [filtroDM, setFiltroDM] = useState("");
  const [filtroEC, setFiltroEC] = useState("");

  // Sección colapsable "Criterios de postulantes NO APTOS" (oculta por defecto
  // para dejar la tabla de Resumen por Evaluado más arriba).
  const [mostrarCriterios, setMostrarCriterios] = useState(false);

  const _fortalezas = [
    "Optimismo",
    "Esperanza",
    "Autoeficacia",
    "Resiliencia",
    "Prudencia",
    "Autorregulación",
    "Responsabilidad",
    "Vitalidad",
    "Apertura",
  ];

  const _riesgos = [
    "Exceso de Confianza",
    "Pesimismo",
    "Desesperanza",
    "Ineficacia",
    "Fragilidad",
    "Cinismo",
    "Superstición",
    "Influencia Social",
    "Sobre valor de sí mismo",
    "Juicio",
  ];

  const _riesgos_sin_juicio = [
    "Exceso de Confianza",
    "Pesimismo",
    "Desesperanza",
    "Ineficacia",
    "Fragilidad",
    "Cinismo",
    "Superstición",
    "Influencia Social",
    "Sobre valor de sí mismo",
  ];

  const _comb_virtuosa = [
    "Autoeficacia - Fragilidad",
    "Autoeficacia - Desesperanza",
    "Autoeficacia - Pesimismo",
  ];

  const _comb_riesgosa = ["Resiliencia - Fragilidad", "Optimismo - Ineficacia"];

  const _distorsion_motivacional = [
    "Resiliencia - Fragilidad",
    "Esperanza - Desesperanza",
  ];

  const _antifortaleza = [
    "Prudencia",
    "Autorregulación",
    "Responsabilidad",
    "Vitalidad",
    "Apertura",
  ];

  const _alertas = ["Distorsión Motivacional", "Evasión Conductual"];

  const HandleClickReporteDetalle = (props) => {
    console.log("Click Reporte");
    navigate("/reporte_detalle");
  };

  const toggleRowExpansion = (rut) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rut]: !prev[rut],
    }));
  };

  // Carga dinámica del reporte desde el backend al montar el componente.
  const { rows: _listado1, totales: _totales } = useSelector(
    (state) => state.reporte,
  );

  useEffect(() => {
    dispatch(
      getReporte({
        token: "c3649ba4e3a81815",
        function: "GetReporte",
        params: { id_proceso: ID_PROCESO },
      }),
    );
    // Mount-only: no incluimos dispatch en deps para evitar loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Guard: mientras los datos no han llegado, mostrar spinner.
  // Debe ir ANTES de cualquier cálculo derivado (.filter, .length sobre
  // _listado1, _totales[...]) porque crashearían con array/objeto vacío.
  if (!_listado1 || _listado1.length === 0) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" role="status" />
        <p className="text-secondary mt-3">Cargando resultados...</p>
      </Container>
    );
  }

  // Variables del gráfico cambian segun los fitros seleccionados

  const _total = _listado1.length;

  const _total_apto = _listado1.filter(
    (item) => item.RESULTADO === "APTO",
  ).length;
  const _total_no_apto = _listado1.filter(
    (item) => item.RESULTADO === "NO APTO",
  ).length;

  const _total_riesgos = _listado1.filter(
    (item) => parseInt(item.Total_Riesgo || 0) >= 3,
  ).length;
  const _total_DM = _listado1.filter(
    (item) => parseInt(item.Total_DM || 0) >= 1,
  ).length;
  const _total_AF = _listado1.reduce(
    (sum, item) => sum + parseInt(item.Total_AF || 0),
    0,
  );
  const _total_EC = _listado1.filter(
    (item) => parseInt(item.Total_EC || 0) >= 1,
  ).length;
  const _juicio = _listado1.filter((item) => item.JUI === "R").length;

  // Count items with "R" for each element
  const _total_ECO = _listado1.filter((item) => item.ECO === "R").length;
  const _total_PES = _listado1.filter((item) => item.PES === "R").length;
  const _total_DES = _listado1.filter((item) => item.DES === "R").length;
  const _total_INE = _listado1.filter((item) => item.INE === "R").length;
  const _total_FRA = _listado1.filter((item) => item.FRA === "R").length;
  const _total_CIN = _listado1.filter((item) => item.CIN === "R").length;
  const _total_SUP = _listado1.filter((item) => item.SUP === "R").length;
  const _total_ISO = _listado1.filter((item) => item.ISO === "R").length;
  const _total_SSV = _listado1.filter((item) => item.SSV === "R").length;
  const _total_JUI = _listado1.filter((item) => item.JUI === "R").length;

  // Count items with "D" for each element
  const _total_PRU = _listado1.filter((item) => item.PRU === "D").length;
  const _total_AUT = _listado1.filter((item) => item.AUT === "D").length;
  const _total_RES = _listado1.filter((item) => item.RES === "D").length;
  const _total_VIT = _listado1.filter((item) => item.VIT === "D").length;
  const _total_APE = _listado1.filter((item) => item.APE === "D").length;

  // Opciones para el select de Resultado (valores distintos del listado).
  const _opcionesResultado = [
    ...new Set(_listado1.map((i) => i.RESULTADO).filter(Boolean)),
  ].sort();

  // Opciones numéricas distintas (orden ascendente) para los selects de
  // Riesgos, Anti Fortaleza, Distorsión Motivacional y Evasión Conductual.
  const _opcionesNum = (key) =>
    [...new Set(_listado1.map((i) => parseInt(i[key] || 0)))].sort(
      (a, b) => a - b,
    );
  const _opcRiesgos = _opcionesNum("Total_Riesgo");
  const _opcAF = _opcionesNum("Total_AF");
  const _opcDM = _opcionesNum("Total_DM");
  const _opcEC = _opcionesNum("Total_EC");

  // Normalizadores para búsqueda por aproximación (substring).
  const _norm = (s) =>
    (s || "")
      .normalize("NFD")
      .replace(new RegExp("[\\u0300-\\u036f]", "g"), "") // quita acentos
      .toLowerCase()
      .trim();
  const _normRut = (s) => (s || "").toLowerCase().replace(/[.\s]/g, ""); // ignora puntos/espacios

  // Listado filtrado (los filtros combinan con AND). Solo afecta la tabla
  // "Resumen por Evaluado", no los totales/graficos superiores.
  const _listadoFiltrado = _listado1.filter(
    (item) =>
      (!filtroResultado || item.RESULTADO === filtroResultado) &&
      (!filtroNombre || _norm(item.nombre).includes(_norm(filtroNombre))) &&
      (!filtroRut || _normRut(item.rut).includes(_normRut(filtroRut))) &&
      (!filtroRiesgos ||
        String(parseInt(item.Total_Riesgo || 0)) === filtroRiesgos) &&
      (!filtroJuicio ||
        (filtroJuicio === "R" ? item.JUI === "R" : item.JUI !== "R")) &&
      (!filtroAF || String(parseInt(item.Total_AF || 0)) === filtroAF) &&
      (!filtroDM || String(parseInt(item.Total_DM || 0)) === filtroDM) &&
      (!filtroEC || String(parseInt(item.Total_EC || 0)) === filtroEC),
  );

  return (
    <Container>
      <Row>
        <Col>
          <Row className="">
            <Col md={3} className="">
              <span className="align-middle">Proceso N° 260521</span>
            </Col>
            <Col md={9} className="">
              <span className="align-middle xz-titulo1 fs-4 fw-bold">
                Cu4400{" "}
              </span>
            </Col>
          </Row>
          <Row>
            <Col md={3}>Fecha</Col>
            <Col md={9}>
              <span className="fs-5 text-secondary text-start">21/05/2026</span>
            </Col>
          </Row>{" "}
          <Row>
            <Col md={3}>Cantidad</Col>
            <Col md={9}>
              {" "}
              <span className="fs-5 text-secondary text-start fw-bold">
                {_listado1.length}
              </span>
            </Col>
          </Row>{" "}
          <Row>
            <Col md={3}>Estado</Col>
            <Col md={9}>
              <span className="text-danger fw-bold fs-5">Concluído</span>
            </Col>
          </Row>{" "}
          <Row>
            <Col md={3}>Ficha Técnica</Col>
            <Col md={9}>
              <a
                href={`${process.env.PUBLIC_URL}/data/Ficha_Tecnica_260521_v1.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="xz-btn-ficha"
                  style={{
                    borderColor: "rgb(84, 47, 25)",
                    color: "rgb(84, 47, 25)",
                  }}
                >
                  <Icon_File size={16} className="me-1" />
                  Ver PDF
                </Button>
              </a>
            </Col>
          </Row>{" "}
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md={3}>
          <h4 className="xz-titulo1">Resultado</h4>
          <Row>
            {/*             <Col md={2} className="text-end">
              Género{" "}
            </Col>
            <Col md={3}>
              <Form.Select size="sm">
                <option>Femenino</option>
                <option>Masculino</option>
                <option>Otra</option>
              </Form.Select>
            </Col>
            <Col md={2} className="text-end">
              Origen{" "}
            </Col>
            <Col md={3}>
              <Form.Select size="sm">
                <option>Inacap</option>
                <option>Esed 1</option>
                <option>Esed 2</option>
                <option>Esed 3</option>
              </Form.Select>
            </Col> */}
          </Row>
          <GraficoDonut datos={[_total_apto, _total_no_apto]} />
        </Col>
        <Col md={4}>
          <h6 className="titulo1" style={{ fontSize: "0.85rem" }}>
            Porcentaje de evaluados con riesgos
          </h6>
          <Row>
            <div style={{ height: "290px", marginBottom: "0px" }}>
              <GraficoHorizontal
                datos={[
                  parseFloat(((_total_ECO / _total) * 100).toFixed(1)),
                  parseFloat(((_total_PES / _total) * 100).toFixed(1)),
                  parseFloat(((_total_DES / _total) * 100).toFixed(1)),
                  parseFloat(((_total_INE / _total) * 100).toFixed(1)),
                  parseFloat(((_total_FRA / _total) * 100).toFixed(1)),
                  parseFloat(((_total_CIN / _total) * 100).toFixed(1)),
                  parseFloat(((_total_SUP / _total) * 100).toFixed(1)),
                  parseFloat(((_total_ISO / _total) * 100).toFixed(1)),
                  parseFloat(((_total_SSV / _total) * 100).toFixed(1)),
                  parseFloat(((_total_JUI / _total) * 100).toFixed(1)),
                ]}
                etiquetas={_riesgos}
                titulo=""
              ></GraficoHorizontal>
            </div>
          </Row>
        </Col>
        <Col md={4}>
          <h6 className="titulo1" style={{ fontSize: "0.85rem" }}>
            Porcentaje de evaluados con antifortalezas
          </h6>

          <Row>
            <div style={{ height: "160px", marginBottom: "20px" }}>
              <GraficoHorizontal1
                datos={[
                  parseFloat(((_total_PRU / _total) * 100).toFixed(1)),
                  parseFloat(((_total_AUT / _total) * 100).toFixed(1)),
                  parseFloat(((_total_RES / _total) * 100).toFixed(1)),
                  parseFloat(((_total_VIT / _total) * 100).toFixed(1)),
                  parseFloat(((_total_APE / _total) * 100).toFixed(1)),
                ]}
                etiquetas={_antifortaleza}
                titulo=""
              ></GraficoHorizontal1>
            </div>{" "}
          </Row>
          <h6 className="titulo1" style={{ fontSize: "0.85rem" }}>
            Porcentaje de evaluados con alertas de conductas críticas de riesgo
          </h6>

          <Row>
            <div style={{ height: "80px", marginBottom: "5px" }}>
              <GraficoHorizontal2
                datos={[
                  parseFloat(((_total_DM / _total) * 100).toFixed(1)),
                  parseFloat(((_total_EC / _total) * 100).toFixed(1)),
                ]}
                etiquetas={_alertas}
                titulo=""
              ></GraficoHorizontal2>
            </div>
          </Row>
        </Col>
      </Row>
      <hr />
      <div
        className="xz-titulo1 d-flex align-items-center"
        style={{ fontSize: "1.20rem", cursor: "pointer" }}
        onClick={() => setMostrarCriterios((v) => !v)}
      >
        {mostrarCriterios ? (
          <Icon_ChevronUp size={18} className="me-2" />
        ) : (
          <Icon_ChevronDown size={18} className="me-2" />
        )}
        Criterios de postulantes NO APTOS
      </div>
      <Collapse in={mostrarCriterios}>
        <div>
          <Row>
            <Col md={3}></Col>
        <Col>
          <Table size="sm" style={{ tableLayout: "fixed" }}>
            <thead>
              <tr className="xz-tb-titulo1">
                <th className="w-50">CRITERIO</th>
                <th className="w-35">INDICADOR</th>
                <th className="w-15">BAREMO</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ height: "60px" }}>
                <td className="xz-tb-texto1">Riesgo</td>
                <td className="xz-tb-texto2">
                  Presencia de 3 o más Riesgos (del total de 10 riesgos)
                </td>
                <td className="xz-tb-texto3">
                  La media aritmética del grupo más 0,7 desviaciones estándar.
                  <br />
                  Área bajo la curva 0,7580
                </td>
              </tr>
              <tr style={{ height: "60px" }}>
                <td className="xz-tb-texto1">Anti Fortaleza</td>
                <td className="xz-tb-texto2">
                  Presencia de 3 o más Anti Fortalezas (del total de 5
                  AntiFortalezas)
                </td>
                <td className="xz-tb-texto3">
                  La media aritmética del grupo menos 0,7 desviaciones estándar.
                  <br />
                  Área bajo la curva 0,2419
                </td>
              </tr>
              <tr style={{ height: "60px" }}>
                <td className="xz-tb-texto1">
                  Alerta de Conducta Crítica de Riesgo (CCR) en Prueba
                  Situacional
                </td>
                <td className="xz-tb-texto2">
                  7 o más respuestas incorrectas o, 2 o más respuestas CCR
                </td>
                <td className="xz-tb-texto3"></td>
              </tr>

              <tr style={{ height: "60px" }}>
                <td className="xz-tb-texto1">Evasión Conductual </td>
                <td className="xz-tb-texto2">
                  Más de 50% de evasión en preguntas tipo Likert 5
                </td>
                <td></td>
              </tr>
              <tr style={{ height: "60px" }}>
                <td className="xz-tb-texto1">Distorsión motivacional </td>
                <td className="xz-tb-texto2">
                  Presente en 100% de los instrumentos donde se evalúa (4)
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
        </div>
      </Collapse>

      {/*       <h4 className="mt-4">
        Alertas Conductas Críticas de Riesgo
        <span className="titulo2"></span>
      </h4>
      <Row className="xz-row-2">
        <Col md={3} className="titulo3">
          <span className="align-middle">Alerta de Juicio Operacional</span>
        </Col>
        <Col md={1} className="titulo1">
          <span className="align-middle">5 de 24</span>
        </Col>
        <Col md={8} className="fw-bold">
          <p>
            Identifica la cantidad de casos donde se detectaron juicios
            riesgosos. La persona toma decisiones ante escenarios operacionales,
            introduciendo incertidumbre y generando riesgos críticos en la
            operación.{" "}
          </p>
          <p>
            Esta dimensión permite controlar la generación de riesgos a partir
            de evitar que personas que declaran que incurrirían en una
            desviación conductual ingresen a operar a la compañía.
          </p>
        </Col>
      </Row>
      <br />
      <Row className="xz-row-2">
        <Col md={3} className="titulo3 ">
          <span className="align-middle">Alerta de Evasión Conductual</span>
        </Col>
        <Col md={1} className="titulo1">
          <span className="align-middle">4 de 24</span>
        </Col>
        <Col md={8} className="fw-bold">
          Identifica la cantidad de casos donde se detectaron personas que
          evitan identificarse con las alternativas. La persona tiende a marcar
          el centro, es decir no tiene claridad de cómo conducirse o comportarse
          ante las preguntas, lo que introduce incertidumbre comportamental,
          generando un riesgo.
        </Col>
      </Row> */}
      {/*
      <h4 className="mt-4">
        Riesgos<span className="titulo2"></span>
      </h4>

      <h4 className="mt-4">
        Fortalezas<span className="titulo2"></span>
      </h4>

      <h4 className="mt-4">
        Combinaciones Virtuosas y Riesgosas<span className="titulo2"></span>
      </h4>
      */}
      <hr />
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h4 className="xz-titulo1 mb-0" style={{ fontSize: "1.20rem" }}>
          Resumen por Evaluado
        </h4>
        <Button
          variant="outline-secondary"
          size="sm"
          style={{ fontSize: "0.7rem", padding: "2px 8px" }}
          onClick={() => setExpandedRows({})}
        >
          Colapsar todo
        </Button>
      </div>
      <Row className="mb-2 g-2">
        <Col xs={12} md={3}>
          <Form.Select
            size="sm"
            value={filtroResultado}
            onChange={(e) => setFiltroResultado(e.target.value)}
          >
            <option value="">Resultado: todos</option>
            {_opcionesResultado.map((v) => (
              <option key={v} value={v}>
                {v}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col xs={12} md={4}>
          <Form.Control
            type="text"
            size="sm"
            placeholder="Buscar por nombre..."
            value={filtroNombre}
            onChange={(e) => setFiltroNombre(e.target.value)}
          />
        </Col>
        <Col xs={12} md={3}>
          <Form.Control
            type="text"
            size="sm"
            placeholder="Buscar por RUT..."
            value={filtroRut}
            onChange={(e) => setFiltroRut(e.target.value)}
          />
        </Col>
        <Col xs={12} md={2} className="d-flex align-items-center">
          <Button
            variant="outline-secondary"
            size="sm"
            style={{ fontSize: "0.7rem", padding: "2px 8px" }}
            onClick={() => {
              setFiltroResultado("");
              setFiltroNombre("");
              setFiltroRut("");
              setFiltroRiesgos("");
              setFiltroJuicio("");
              setFiltroAF("");
              setFiltroDM("");
              setFiltroEC("");
            }}
          >
            Limpiar filtros
          </Button>
        </Col>
      </Row>
      <Row className="mb-3 g-2">
        <Col xs={6} sm={4} md={2}>
          <Form.Select
            size="sm"
            value={filtroRiesgos}
            onChange={(e) => setFiltroRiesgos(e.target.value)}
          >
            <option value="">Riesgos: todos</option>
            {_opcRiesgos.map((n) => (
              <option key={n} value={String(n)}>
                {n}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col xs={6} sm={4} md={2}>
          <Form.Select
            size="sm"
            value={filtroJuicio}
            onChange={(e) => setFiltroJuicio(e.target.value)}
          >
            <option value="">Juicio: todos</option>
            <option value="R">R</option>
            <option value="SIN">Sin</option>
          </Form.Select>
        </Col>
        <Col xs={6} sm={4} md={2}>
          <Form.Select
            size="sm"
            value={filtroAF}
            onChange={(e) => setFiltroAF(e.target.value)}
          >
            <option value="">Antifortaleza: todos</option>
            {_opcAF.map((n) => (
              <option key={n} value={String(n)}>
                {n}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col xs={6} sm={4} md={2}>
          <Form.Select
            size="sm"
            value={filtroDM}
            onChange={(e) => setFiltroDM(e.target.value)}
          >
            <option value="">DM: todos</option>
            {_opcDM.map((n) => (
              <option key={n} value={String(n)}>
                {n}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col xs={6} sm={4} md={2}>
          <Form.Select
            size="sm"
            value={filtroEC}
            onChange={(e) => setFiltroEC(e.target.value)}
          >
            <option value="">EC: todos</option>
            {_opcEC.map((n) => (
              <option key={n} value={String(n)}>
                {n}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="xz-table-scroll-container">
            <Table className="xz-table-esg">
              <thead>
                <tr>
                  <th style={{ width: "40px" }}>N°</th>
                  <th style={{ width: "20%" }}>Nombre</th>
                  <th
                    className="d-none d-md-table-cell"
                    style={{ width: "12%" }}
                  >
                    RUT
                  </th>
                  <th>Resultado</th>
                  <th className="d-none d-md-table-cell">Riesgos</th>
                  <th className="d-none d-md-table-cell">Juicio</th>
                  <th className="d-none d-md-table-cell">Anti Fortaleza</th>
                  <th className="d-none d-md-table-cell">Dist. Motivacional</th>
                  <th className="d-none d-md-table-cell">Evasión Conductual</th>
                  <th className="d-none d-lg-table-cell">Criterios</th>
                  {_esAdmin && (
                    <th className="text-center" style={{ width: "80px" }}>
                      Ficha
                    </th>
                  )}
                  <th style={{ width: "30px" }}></th>
                </tr>
              </thead>
              <tbody>
                {_listadoFiltrado
                  .sort((a, b) => {
                    // 1. Resultado (ASC: APTO antes que NO APTO)
                    const cmpResultado = a.RESULTADO.localeCompare(
                      b.RESULTADO,
                    );
                    if (cmpResultado !== 0) return cmpResultado;

                    // 2. Juicio (ASC: "" antes que "R")
                    const cmpJuicio = (a.JUI || "").localeCompare(b.JUI || "");
                    if (cmpJuicio !== 0) return cmpJuicio;

                    // 3. Total Riesgos (ASC numérico)
                    const cmpRiesgos =
                      parseInt(a.Total_Riesgo || 0) -
                      parseInt(b.Total_Riesgo || 0);
                    if (cmpRiesgos !== 0) return cmpRiesgos;

                    // 4. Anti Fortalezas (ASC numérico)
                    const cmpAF =
                      parseInt(a.Total_AF || 0) - parseInt(b.Total_AF || 0);
                    if (cmpAF !== 0) return cmpAF;

                    // 5. Distorsión Motivacional (ASC numérico)
                    const cmpDM =
                      parseInt(a.Total_DM || 0) - parseInt(b.Total_DM || 0);
                    if (cmpDM !== 0) return cmpDM;

                    // 6. Evasión Conductual (ASC numérico)
                    const cmpEC =
                      parseInt(a.Total_EC || 0) - parseInt(b.Total_EC || 0);
                    if (cmpEC !== 0) return cmpEC;

                    return a.nombre.localeCompare(b.nombre);
                  })
                  .map((item, index) => {
                    const isExpanded = expandedRows[`tbl_${item.rut}`];
                    return (
                      <React.Fragment key={item.rut}>
                        <tr
                          className={
                            DETALLE_EXPANDIBLE ? "xz-row-clickable" : undefined
                          }
                          onClick={
                            DETALLE_EXPANDIBLE
                              ? () =>
                                  setExpandedRows((prev) => ({
                                    ...prev,
                                    [`tbl_${item.rut}`]:
                                      !prev[`tbl_${item.rut}`],
                                  }))
                              : undefined
                          }
                        >
                          <td
                            style={{
                              backgroundColor:
                                item.RESULTADO === "APTO"
                                  ? "rgb(17,135,171)"
                                  : "#c0504d",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td style={{ fontWeight: 600, color: "#333" }}>
                            {item.nombre}
                          </td>
                          <td className="d-none d-md-table-cell">{item.rut}</td>
                          <td
                            style={{
                              fontWeight: 700,
                              color:
                                item.RESULTADO === "APTO"
                                  ? "#2e7d32"
                                  : "#c0504d",
                            }}
                          >
                            {item.RESULTADO}
                          </td>
                          <td className="text-center d-none d-md-table-cell">
                            {item.Total_Riesgo !== "0" ? item.Total_Riesgo : ""}
                          </td>
                          <td className="text-center d-none d-md-table-cell">
                            {item.JUI === "R" ? "R" : ""}
                          </td>
                          <td className="text-center d-none d-md-table-cell">
                            {item.Total_AF !== "0" ? item.Total_AF : ""}
                          </td>
                          <td className="text-center d-none d-md-table-cell">
                            {item.Total_DM !== "0" ? item.Total_DM : ""}
                          </td>
                          <td className="text-center d-none d-md-table-cell">
                            {item.Total_EC !== "0" ? item.Total_EC : ""}
                          </td>
                          <td
                            className="d-none d-lg-table-cell"
                            style={{ fontSize: "0.78rem" }}
                          >
                            {item.OBSERVACIONES}
                          </td>
                          {_esAdmin && (
                            <td className="text-center">
                              <Button
                                variant="outline-primary"
                                size="sm"
                                className="xz-btn-ficha"
                                style={{
                                  borderColor: "rgb(84, 47, 25)",
                                  color: "rgb(84, 47, 25)",
                                }}
                                title="Ver ficha detallada"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`/ficha/${item.id_usuario}`);
                                }}
                              >
                                <Icon_Ficha size={16} />
                              </Button>
                            </td>
                          )}
                          <td className="text-center">
                            {DETALLE_EXPANDIBLE &&
                              (isExpanded ? (
                                <Icon_ChevronUp size={14} />
                              ) : (
                                <Icon_ChevronDown size={14} />
                              ))}
                          </td>
                        </tr>
                        {DETALLE_EXPANDIBLE && isExpanded && (
                          <tr className="xz-row-detail">
                            <td colSpan={_esAdmin ? 12 : 11}>
                              <DetalleCalculosEvaluado
                                item={item}
                                totales={_totales}
                              />
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Reporte260521;
